import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import {
  FluentProvider,
  teamsLightTheme,
  Button,
} from '@fluentui/react-components';

const ConsentScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const referenceCode = location.state?.referenceCode || "";

  return (
    <FluentProvider theme={teamsLightTheme}>
      <div style={{ padding: 20, maxWidth: 400, minHeight: '90vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        
        <div>
          <div>
            <Button appearance="subtle" icon={<span style={{display:'inline-block',transform:'rotate(180deg)'}}>&#8594;</span>} onClick={() => navigate(-1)} aria-label="Back" />
          </div>
          <div style={{ marginTop: 16 }}>
            <div style={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
              Health Partners Transcript Assistant
            </div>
            <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>
              {referenceCode}
            </div>
          </div>

          <div style={{ marginTop: 32, fontSize: '1rem', lineHeight: 1.5 }}>
            Do all attendees in the meeting<br />
            consent to the transcript<br />
            recording of this meeting?
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 32 }}>
          <Button appearance="secondary">Disagree</Button>
          <Button appearance="primary" onClick={() => navigate("/formSelection", { state: { referenceCode } })}>Agree</Button>
        </div>
      </div>
    </FluentProvider>
  );
};

export default ConsentScreen;
